import { withRouter } from 'react-router'
import MenuFooter from '../components/MenuFooter'
import { connect } from 'react-redux'
import { compose, graphql } from 'react-apollo';
import { getMenuFooters } from "../graphqlDic";

export default compose(
    graphql(getMenuFooters,{
        name:'getMenuFooters'
    })
)(withRouter(
    connect(
        null,
        null
    )(MenuFooter)
));



// WEBPACK FOOTER //
// ./src/containers/GetMenuFooter.js